<template>
    <div>
        <h1>Sign Up</h1>
        <b-form @submit="onSubmit" @reset="onReset" class="sign-up">
            <!-- name group -->
            <b-form-group
                id="name-input-group"
            >
                <label class="input-heading"><h5>Name:</h5></label>
                <b-form-input
                    class="user-input"
                    id="name-input"
                    v-model="form.name"
                    placeholder="Please enter your name"
                    required
                ></b-form-input>
                <b-form-invalid-feedback :state="nameValidation" v-if="formSubmitted">
                    Please enter your name.
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="nameValidation" v-if="formSubmitted">
                    Good to go.
                </b-form-valid-feedback>
            </b-form-group>
            <!-- email group -->
            <b-form-group
                id="email-input-group"
            >
                <label class="input-heading"><h5>Email:</h5></label>
                <b-form-input
                    class="user-input"
                    id="email-input"
                    type="email"
                    v-model="form.email"
                    placeholder="Please enter your email"
                    required
                ></b-form-input>
                <b-form-invalid-feedback v-if="formSubmitted">
                    Please enter your email.
                </b-form-invalid-feedback>
                <b-form-valid-feedback v-if="formSubmitted">
                    Good to go.
                </b-form-valid-feedback>
            </b-form-group>
            <!-- password group -->
            <b-form-group
                id="password-input-group"
            >
                <label class="input-heading"><h5>Password:</h5></label>
                <b-form-input
                    class="user-input"
                    id="password-input"
                    type="password"
                    v-model="form.password"
                    placeholder="Please enter a password"
                    required
                ></b-form-input>
                <b-form-text id="password-help-block">
                    Your password must be 8-20 characters long, contain letters and numbers,
                    and must not contain spaces, special characters, or emoji.
                </b-form-text>
                <b-form-invalid-feedback :state="passwordValidation" v-if="formSubmitted">
                    Please make sure your password is at least 8 characters.
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="passwordValidation" v-if="formSubmitted">
                    Good to go.
                </b-form-valid-feedback>
            </b-form-group>
            <!-- confirm password group -->
            <b-form-group
                id="confirm-password-input-group"
            >
                <label class="input-heading"><h5>Confirm Password:</h5></label>
                <b-form-input
                    class="user-input"
                    id="confirm-password-input"
                    type="password"
                    v-model="form.confirmPassword"
                    placeholder="Please reenter your password"
                    required
                ></b-form-input>
                <b-form-invalid-feedback
                    :state="confirmPasswordValidation"
                    v-if="passwordValidation"
                >
                    Please make sure your passwords match.
                </b-form-invalid-feedback>
                <b-form-valid-feedback :state="confirmPasswordValidation" v-if="passwordValidation">
                    Good to go.
                </b-form-valid-feedback>
            </b-form-group>
            <!-- submit buttons -->
            <b-button
              type="submit"
              variant="success"
              class="submit-buttons">Create Account</b-button>
            <b-button
              type="reset"
              variant="danger"
              class="submit-buttons">Reset Choices</b-button>
        </b-form>
    </div>
</template>

<script>
import firebase from 'firebase';
// import { useRemoteServer } from '../variables';

export default {
    data() {
        return {
            formSubmitted: false,
            form: {
                name: '',
                email: '',
                password: '',
                confirmPassword: '',
            },
        };
    },
    methods: {
        onSubmit(event) {
            event.preventDefault();
            this.formSubmitted = true;

            // will have to make this more secure
            console.log('this is the form information: ');
            console.log(this.form);
            this.register();
            this.formSubmitted = false;
        },
        onReset(event) {
            event.preventDefault();
            console.log('reset');
            this.form = {
                name: '',
                email: '',
                password: '',
                confirmPassword: '',
            };
        },
        register() {
            firebase
                .auth()
                .createUserWithEmailAndPassword(this.form.email, this.form.password)
                .then(async () => {
                    console.log('Successfully registered! Please login.');
                    await this.updateUser();

                    // next portion could probably be refactored,
                    // also probably made into a separate function
                    const user = firebase.auth().currentUser;
                    // console.log(user.uid);
                    const usersRef = firebase.database().ref('data/users/');
                    usersRef.child(user.uid).child('uid').set(user.uid);
                    usersRef.child(user.uid).child('saved').set('');

                    this.$router.push('/profile');
                })
                .catch((error) => {
                    console.log(error.message);
                });
        },
        async updateUser() {
            // copied this code from somewhere else in project, should all be moved into one file
            // to prevent duplication
            console.log('did this update??');
            const user = firebase.auth().currentUser;
            console.log('this is the current user ', user);
            await user.updateProfile({
                displayName: this.form.name,
            }).then(() => {
                console.log('name successfully added');
            }).catch((error) => {
                console.log('an error occurred ', error);
            });
        },
    },
    computed: {
        nameValidation() {
            return (this.form.name.trim().length > 0);
        },
        passwordValidation() {
            return this.form.password.trim().length >= 8 && this.form.password.trim().length <= 20;
        },
        confirmPasswordValidation() {
            // eslint-disable-next-line max-len
            const toReturn = this.passwordValidation && this.form.confirmPassword === this.form.password;
            console.log('password confirmed: ', toReturn);
            return toReturn;
        },
    },
};
</script>

<style scoped>

.sign-up {
    width: 80%;
    margin: auto;
    background-color: white;
    padding: 2%;
}

.submit-buttons {
    margin: 10px;
}

h5 {
    font-weight: bold;
    color: black;
}
/* .feedback {
    text-decoration: aliceblue;
} */
</style>
